export default {
  LOADING_COLOR: '#007dcc',
  SUCCESS_COLOR: '#4fc47f',
  PRIMARY_COLOR: '#007dcc',
  WARNING_COLOR: '#f0ad4e',
  DANGER_COLOR: '#f35a3d',
};
